import React from 'react';
import { VaBreadcrumbs } from '@department-of-veterans-affairs/web-components/react-bindings';
import { TITLE } from '../constants';

const Breadcrumbs = () => {
  const crumbs = [
    {
      href: '/',
      label: 'VA.gov',
    },
    {
      href: '/forms',
      label: 'VA forms',
    },
    {
      href: '/forms/22-10272',
      label:
        'Reimbursement form for prep courses for licensing or certification tests',
    },
    {
      href: 'forms/22-10272/request-prep-course-reimbursement',
      label: TITLE,
    },
  ];
  return (
    <div className="row">
      <div className="vads-u-margin-left--2 mobile-lg:vads-u-margin-left--1">
        <VaBreadcrumbs
          breadcrumbList={crumbs}
          data-testid="breadcrumbs"
          homeVeteransAffairs={false}
          wrapping
        />
      </div>
    </div>
  );
};

export default Breadcrumbs;
